import { Dispatch, SetStateAction, createContext } from 'react'

export type PatchNotesType = {
  categoriesFilters: any
  setCategoriesFilters: Dispatch<SetStateAction<any>>
  modulesFilters: any
  setModulesFilters: Dispatch<SetStateAction<any>>
}

const defaultValues = {
  categoriesFilters: {
    ADJUSTMENTS: true,
    ADVERTISEMENT: true,
    FEATURE: true,
    FIX: true,
  },
  setCategoriesFilters: () => {},
  modulesFilters: {
    ACTIVITIES: true,
    APP_CITIZEN: true,
    ATTENDANCES: true,
    CITIZEN_PORTAL: true,
    CITIZEN_PROFILE: true,
    DATA_INTEGRATOR: true,
    DIGITAL_ARCHIVE: true,
    GEO: true,
    INSTITUTIONAL_MANAGEMENT: true,
    INVENTORY: true,
    MESSENGER: true,
    OBSERVATORY: true,
    PROCESSES_AND_DOCUMENTS: true,
    REGULATION: true,
    SCHEDULES: true,
    SERVICES_LETTER: true,
    UNIFIED_LOGIN: true,
    VULNERABILITY_ALERTS: true,
    GENERAL: true,
  },
  setModulesFilters: () => {},
}

const PatchNotesContext = createContext<PatchNotesType>(defaultValues)

export default PatchNotesContext
